/**
 * @file OAuthButtonsSlot.tsx
 *
 * @fileoverview Prints custom oauth buttons.
 */

import React from 'react';

export const OAuthButtonsSlot = ({
  gdpr,
  consentInfos,
  isRecruiterContext,
}) => {
  return <></>;
};
export default OAuthButtonsSlot;
